'use client';

import React from 'react';
import { useVoice } from '@/components/providers/VoiceProvider';
import { X, Mic, MicOff, Volume2 } from 'lucide-react';

export function VoiceFloatingControls() {
  const {
    isConnected,
    isListening,
    isSpeaking,
    disconnect,
    stopListening,
    startListening,
    resumeAudioContext,
  } = useVoice();

  if (!isConnected) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 flex items-center gap-2 bg-background border border-border shadow-lg rounded-full px-4 py-2 animate-in slide-in-from-bottom-5">
      <div className="flex items-center gap-3">
        {/* Status Indicator */}
        <div className={`relative flex h-3 w-3`}>
          {(isListening || isSpeaking) && (
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75"></span>
          )}
          <span
            className={`relative inline-flex rounded-full h-3 w-3 ${isSpeaking ? 'bg-green-500' : isListening ? 'bg-primary' : 'bg-muted-foreground'}`}
          ></span>
        </div>

        <span className="text-sm font-medium">
          {isSpeaking ? 'Speaking...' : isListening ? 'Listening...' : 'Connected'}
        </span>

        <div className="h-4 w-px bg-border mx-1" />

        {/* Mic Toggle */}
        <button
          onClick={async () => {
            if (!isListening) {
              await resumeAudioContext();
              startListening();
            } else {
              stopListening();
            }
          }}
          className="p-1.5 hover:bg-muted rounded-full transition-colors"
          title={isListening ? 'Mute Microphone' : 'Unmute Microphone'}
        >
          {isListening ? (
            <Mic className="h-4 w-4" />
          ) : (
            <MicOff className="h-4 w-4 text-muted-foreground" />
          )}
        </button>

        {/* Disconnect */}
        <button
          onClick={disconnect}
          className="p-1.5 hover:bg-destructive/10 text-muted-foreground hover:text-destructive rounded-full transition-colors"
          title="Disconnect Voice"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
